import {
    IMAGE_STYLE_FIXED,
    STANDARD_STYLE,
} from '@eventbrite/eds-media-card-content';
import React from 'react';
import { SearchEventCardProps } from '../../types/index';
import { SearchEventCard } from './SearchEventCard';

const IMAGE_STYLE_SQUARE = 'square';
const MINI_STYLE = 'mini';

export class SearchEventCardStyleSwitcher extends React.PureComponent<
    SearchEventCardProps
> {
    render() {
        return (
            <div>
                <div className="search-event-card-rectangle-image">
                    <SearchEventCard
                        {...this.props}
                        style={STANDARD_STYLE}
                        imageStyle={IMAGE_STYLE_FIXED}
                    />
                </div>
                <div className="search-event-card-square-image">
                    <SearchEventCard
                        {...this.props}
                        style={MINI_STYLE}
                        imageStyle={IMAGE_STYLE_SQUARE}
                    />
                </div>
            </div>
        );
    }
}

export default SearchEventCardStyleSwitcher;
